import '../styles/header.scss'
import '../styles/global.scss'
import '../styles/tasklist.scss'

export function Modal() {
  return (
    <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog">
           	<div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title text-primary" id="exampleModalLabel">Erro na inclusão de task</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                Por favor, preencha o campo para incluir uma nova task.
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-primary" data-dismiss="modal">Fechar</button>
              </div>
          	</div>
        </div>
    </div>
  )
}